/**
 * Returns the currency symbol for a restaurant.
 *
 * Resolution order:
 *  1. `restaurantData.currencySymbol`  (Redux / API response)
 *  2. `fallbackRestaurant.currencySymbol` (e.g. value loaded from localStorage)
 *  3. `defaultSymbol` (defaults to '$')
 *
 * The value is always coerced to a string so callers can safely
 * interpolate it into JSX without risking a "Objects are not valid
 * as a React child" crash if the data shape ever changes.
 *
 * @param {object|null} restaurantData
 * @param {object|null} fallbackRestaurant
 * @param {string}      defaultSymbol
 * @returns {string}
 */
export const getCurrencySymbol = (
  restaurantData,
  fallbackRestaurant = null,
  defaultSymbol = "$"
) => {
  if (restaurantData && restaurantData.currencySymbol) {
    return String(restaurantData.currencySymbol);
  }

  if (fallbackRestaurant && fallbackRestaurant.currencySymbol) {
    return String(fallbackRestaurant.currencySymbol);
  }

  return defaultSymbol;
};
